import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appTimeFormat',
})
export class TimeFormatPipe implements PipeTransform {
  transform(time: string): string {
    if (!time || !time.includes(':')) return time;

    const [hour, minute] = time.split(':').map(Number);
    if (isNaN(hour) || isNaN(minute)) return time;

    const h = hour % 12 || 12;
    const ampm = hour >= 12 ? 'PM' : 'AM';

    return `${h.toString().padStart(2, '0')}:${minute
      .toString()
      .padStart(2, '0')} ${ampm}`;
  }
}
